import React from "react";
import CardLayout from "src/layout/CardLayout";
import GridLayout from "src/layout/GridLayout";
import PageDropdownMenu from "src/layout/PageDropdownMenu";

const DrawerMegaMenu = ({ menuItem, closeMenu }) => {
  return (
    <div>
      <div>
        {menuItem.subMenu && menuItem?.subMenuCardData && (
          <CardLayout data={menuItem?.subMenuCardData} closeMenu={closeMenu} />
        )}
      </div>
      {menuItem?.subMenu && menuItem?.subMenuGridData && (
        <GridLayout data={menuItem?.subMenuGridData} closeMenu={closeMenu} />
      )}
      {/* Add support for pages in mobile drawer */}
      {menuItem?.subMenu && menuItem?.subMenuPageData && (
        <div className="p-4">
          <PageDropdownMenu data={menuItem?.subMenuPageData} closeMenu={closeMenu} />
        </div>
      )}
    </div>
  );
};

export default DrawerMegaMenu;